import Select from 'react-select';
import {ErrorMessage } from 'formik'
import { ErrorMsg } from '../components/common/ErrorMsg';

const SelectField = ({ field,form, options }) => {
    const {name, value} = field
    const selectedOption = options.find(option => option.value === value);
    const handleSelectedOptionChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : selectedOption;
    
        const changeEvent = {
          target: {
            name: name,
            value: selectedValue
          }
        };
        field.onChange(changeEvent);
    }

    return (
        <>
          <Select
            {...field}
            value={selectedOption}
            onChange={handleSelectedOptionChange}

            options={options}
          />
          <ErrorMessage name={name} component={ErrorMsg}/>
        </>
    )
}

export default SelectField
